import React, { Component } from "react";
import jwtDecode from "jwt-decode";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Link } from "react-router-dom";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import {
  SignInProps,
  SignInState,
} from "../../../shared/interfaces/components/signin.interface";
import { SigninStateReducer } from "../../../shared/interfaces/reducers/reducer.interface";
import * as actions from "../../../store/signin/actions";
import nexumLogo from "../../../assets/nexumLogo.png";
import { JWT_TYPE, getJWTDecoded } from "../../../../utils/userUtils";

import {
  getTenantDetail,
  updateTenant,
  updateUser,
} from "../../../store/tenant/api";
import Button2 from "../../../shared/components/button/Button2";
import { Lock, Mail } from "lucide-react";
import { updateTenantObj } from "../../../shared/interfaces/components/tenantList.interface";
import { getAuthInstance } from "../../../../utils/firebase";

class SignIn extends Component<SignInProps, SignInState> {
  constructor(props: SignInProps) {
    super(props);
    
    // Extract query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const procurementAccountId = urlParams.get('procurementAccountId') || "";
    const userIdentity = urlParams.get('userIdentity') || "";

    // Store in session storage if present
    if (procurementAccountId) {
      sessionStorage.setItem('procurementAccountId', procurementAccountId);
    }

    if (userIdentity) {
      sessionStorage.setItem('userIdentity', userIdentity);
    }

    // Remove query parameters from URL without refreshing the page
    if (procurementAccountId || userIdentity) {
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
    
    this.state = {
      ...props,
      email: "",
      password: "",
      tenantId: "",
      isEmailOk: false,
      isFirebaseOk: 2,
      idToken: undefined,
      loading: false,
      showNow: false,
      showChoose: false,
      loggingHouse: false,
      loggingNexbot: false,
      loggingNexcode: false,
      ownedProducts: [],
    };
  }

  componentDidMount() {
    this.checkToken();
  }

  // eslint-disable-next-line consistent-return
  componentDidUpdate(prevProps: SignInProps, prevState: SignInState) {
    // set the tenantId in state to call firebase correctly
    if (prevProps !== this.props) {
      this.setState({ showNow: true });
      if (
        this.props.isFirebaseOk === 0 &&
        Object.keys(this.props.firebaseRes).length > 0
      ) {
        this.setState({ loading: false });
      }
      this.setState({ isFirebaseOk: 2 });
    }
    this.setIsUser();
  }

  checkToken() {
    const token = window.localStorage.getItem("token");
    if (token) {
      const decodedToken = getJWTDecoded(token);
      const ownedProducts = this.getOwnedProducts(
        decodedToken.firebase?.tenant || ""
      );
      const tenantName = decodedToken.name;
      window.localStorage.setItem("name", decodedToken.name);
      if (this.props?.product && decodedToken.role < 2) {
        this.props.productList?.forEach((product) => {
          if (product.appCode === this.props.product) {
            if (ownedProducts.includes(product.appCode)) {
              const url = product.appUrl.concat(`?token=${token}`);
              window.open(url, "_self");
            }
          }
        });
      } else {
        const isUser = window.localStorage.getItem("isUser");
        const locationURL =
          decodedToken.role === 0
            ? `/private/tenantlist/`
            : decodedToken.role === 1 && isUser
              ? `/private/userProfile/`
              : `/private/multidetailstenant/`;
        this.props.location(locationURL);
        window.localStorage.setItem("role", decodedToken.role.toString());
        window.localStorage.setItem("uuid", decodedToken.uuid);
        window.localStorage.setItem("name", decodedToken.name);
        if (decodedToken.role === 1) {
          window.localStorage.setItem(
            "tenantId",
            decodedToken.firebase?.tenant || ""
          );
        }
      }
    }
  }

  getOwnedProducts(token: string) {
    const ownedProd: any[] = [];
    const respo: any = getTenantDetail(token).then((res) => {
      const allProd = res?.testProducts;
      allProd?.forEach((element: any) => {
        if (element.paymentStatus === "Paid") {
          ownedProd.push(element.productAppCode);
        }
      });
    });
    return ownedProd;
  }

  async updateProduct(token: string) {
    console.log("");
    if (token) {
      const res: any = await getTenantDetail(token);
    }
  }

  async updateToken() {
    const auth = getAuthInstance(); // Ottieni l'istanza di autenticazione
    try {
      // Ottieni l'utente attuale
      const user = auth.currentUser;

      if (user) {
        // Recupera il token aggiornato
        user.getIdToken(true).then((t) => {
          localStorage.setItem("token", t); // Usa sessionStorage per la sessione corrente
          return Promise.resolve(t);
        }); // 'true' forzare un refresh
        // Memorizza il token in sessionStorage
      }
    } catch (error) {
      console.error("Errore nel recupero del token:", error);
    }
  }

  // TODO FIX THE CHECK WHEN THE GET TENANT WILL HAVE ALL
  // FIELDS AND IMPLEMENT THE CHECK ON THE VALUE
  setIsUser() {
    const token = window.localStorage.getItem("token");
    if (token) {
      const decodedToken = getJWTDecoded(token);
      const tenant: any = getTenantDetail(
        decodedToken.firebase?.tenant || ""
      ).then((res) => {
        console.log("tenant ------------>", res)
        const updateObj: updateTenantObj = {
          id: res?.id || "",
          newOrgName: res.organizationName,
          newOrgEmail: res.organizationEmail,
          newProduct: res.product,
          newCompanyName: res.companyName,
          newVAT: res.VAT,
          newDestinationCode: res.destinationCode,
          newPec: res.pec,
          newEmail: res?.userData?.email ?? "",
          newName: res?.userData?.name ?? "",
          newSurname: res?.userData?.surname ?? "",
          newCity: res?.userData?.city ?? "",
          newProvince: res?.userData?.province ?? "",
          newDateOfBirth: res?.userData?.dateOfBirth ?? "",
          newFiscalCode: res?.userData?.fiscalCode ?? "",
          newAddress: res?.userData?.address ?? "",
          newPhoneNumber: res?.userData?.phoneNumber ?? "",
        };
        if (res?.isUser) {
          window.localStorage.setItem("isUser", "true");
          updateUser(updateObj).then((r) => {
            this.updateToken().then(() => {
              this.checkToken();
            });
          });
        } else {
          updateTenant(updateObj).then((r) => {
            this.updateToken().then(() => {
              this.checkToken();
            });
          });
        }
      });
    }
  }

  render() {
    const { email, loading } = this.state;
    // destructuring props
    const { firebaseInitiateRequest } = this.props;

    // function that sends the mail verification request and then the login request to firebase API
    const sendData = () => {
      this.setState({ loading: true });
      firebaseInitiateRequest(this.state);
    };

    // "onChange" input
    const passwordChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      if (data.target.value.length > 0) {
        this.setState({ password: data.target.value });
      }
    };

    // "onChange" input
    const emailChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ email: data.target.value });
    };

    return (
      <>
        <div className="fixed top-0 bg-blue bg-opacity-10 h-screen w-screen -z-10" />
        <section data-test="signin-wrapper" className="mx-auto mt-40">
          <div className="w-full h-screen login-body mx-auto my-auto">
            <div className="login-wrapper">
              <article className="prova3">
                <div className="loginbox shadow-md grow">
                  <div className="login-left">
                    <img
                      className="img-fluid"
                      src={nexumLogo}
                      alt="nexumLogo"
                    />
                  </div>
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <h1>Login</h1>
                      <p className="account-subtitle">
                        Access your dashboard or your product
                      </p>
                      <div className="form-group">
                        <div className="flex items-center mb-2 flex-row">
                          <Mail className="w-4 h-4 mr-2" />
                          <p>Email</p>
                        </div>
                        <InputFieldComponent
                          data-test="input"
                          name="email"
                          id="signin-email"
                          type="text"
                          label=""
                          value={email}
                          className="min-h-[45px]"
                          title="Insert a valid email"
                          onChangeHandler={emailChange}
                        />
                      </div>
                      <div className="form-group" id="passwordField">
                        <div className="flex items-center mb-2 flex-row">
                          <Lock className="w-4 h-4 mr-2" />
                          <p>Password</p>
                        </div>
                        <InputFieldComponent
                          data-test="input"
                          name="password"
                          id="signin-password"
                          type="password"
                          label=""
                          value={this.state.password}
                          className="min-h-[45px]"
                          title="Insert a valid password"
                          onChangeHandler={passwordChange}
                        />
                      </div>
                      {this.state.showNow &&
                        this.props.isFirebaseOk === 0 &&
                        this.props.code && (
                          <div className="alert alert-danger" role="alert">
                            <strong> {this.props.code} </strong>
                          </div>
                        )}
                      {/* An example to pass a ref to child and set the event */}
                      <div className="form-group mt-2">
                        <Button2
                          type="submit"
                          title="Sign in"
                          isLoading={loading}
                          disabled={loading}
                          className="w-full min-h-[45px]"
                          onClick={() => {
                            sendData();
                          }}
                        />
                        <div className="mt-4">
                          <Link
                            to="/accountRecovery"
                            style={{
                              color: "#0047a5",
                              textDecoration: "underline",
                              textAlign: "center",
                            }}
                          >
                            Forgot your username or password? Recover your
                            account.
                          </Link>
                        </div>
                      </div>
                      <Link
                        to="/signupUser"
                        style={{
                          color: "#0047a5",
                          marginTop: "10px",
                          textDecoration: "underline",
                          textAlign: "center",
                        }}
                      >
                        <p
                          style={{
                            color: "#0047a5",
                            marginTop: "10px",
                            textDecoration: "underline",
                          }}
                        >
                          Don t have an account? Sign up!
                        </p>
                      </Link>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  firebaseInitiateRequest: (payload: SignInState) => {
    dispatch(actions.firebaseInitiateRequest(payload));
  },
});
const mapStateToProps = (state: SigninStateReducer) => ({
  isEmailOk: state.signinReducer.isEmailOk,
  emailApiResponse: state.signinReducer.emailApiResponse,
  isFirebaseOk: state.signinReducer.isFirebaseOk,
  firebaseRes: state.signinReducer.firebaseRes,
  status: state.signinReducer.status,
  code: state.signinReducer.firebaseStatus?.code,
  userRole: state.signinReducer.userRole,
  detailsTenantIsOk: state.tenantsReducer.detailsTenantIsOk,
  detailsTenant: state.tenantsReducer.detailsTenant,
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
